import { FC, useState } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { SeoLink } from 'dibs-elements/exports/SeoLink';
import { PdpSharedRingSizeGuideModalLink } from './PdpSharedRingSizeGuideModalLink';
import { PdpSharedRingSizeGuideModalLazy } from './PdpSharedRingSizeGuideModalLazy';

// types
import { PdpSharedDetailRingSize_detailValues$key as DetailValues } from './__generated__/PdpSharedDetailRingSize_detailValues.graphql';

type Props = {
    currency: string;
    detailValues: DetailValues | null;
};

const detailValuesFragment = graphql`
    fragment PdpSharedDetailRingSize_detailValues on PdpDetailValueInterface @relay(plural: true) {
        ... on PdpDetailRingSize {
            browseUrl
            ringSizes {
                unit
                value
            }
        }
    }
`;

export const PdpSharedDetailRingSize: FC<Props> = ({ detailValues: detailValuesRef, currency }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const detailValues = useFragment(detailValuesFragment, detailValuesRef);
    const detailValue = detailValues?.[0];
    const browseUrl = detailValue?.browseUrl;

    const ringMeasurementType = currency === 'USD' ? 'US' : 'MM';
    const ringSizeDisplay = (detailValue?.ringSizes || []).find(
        size => size?.unit === ringMeasurementType
    )?.value;

    let ringSizeDisplayComponent = null;

    if (browseUrl) {
        const [size, copy] = (ringSizeDisplay || '').split(',');
        ringSizeDisplayComponent = (
            <>
                <SeoLink linkData={{ path: browseUrl, isLinkable: true }}>{size}</SeoLink>
                {copy ? `, ${copy}` : null}
            </>
        );
    } else {
        ringSizeDisplayComponent = <>{ringSizeDisplay}</>;
    }
    return (
        <>
            {ringSizeDisplayComponent}
            <div>
                <PdpSharedRingSizeGuideModalLink onClick={() => setModalOpen(true)} />
                <PdpSharedRingSizeGuideModalLazy
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                />
            </div>
        </>
    );
};
